import {IDocument} from 'types/documents';
import Button from 'components/ui/Button';
import IconSVG from 'components/ui/Icon/IconSVG';
import useModal from 'components/ui/ModalContainer/useModal';
import ConfirmationOverlay from 'components/ui/Overlays/ConfirmationOverlay/ConfirmationOverlay';
import {FileManagement} from 'components/ui/FileUpload/components/UploadedFile';
import styles from './ExpenseDocuments.module.scss';

interface IProps {
    documents: IDocument[];
    expenseFileManagementMethods: FileManagement;
    transactionIri: string;
}

const ExpenseDocuments = ({
    documents,
    expenseFileManagementMethods,
    transactionIri,
}: IProps) => {
    return (
        <div className={styles.container}>
            {documents.map(doc => (
                <ExpenseDocument
                    expenseFileManagementMethods={expenseFileManagementMethods}
                    doc={doc}
                    transactionIri={transactionIri}
                />
            ))}
        </div>
    );
};

export default ExpenseDocuments;

interface IExpenseDocumentProps {
    doc: IDocument;
    expenseFileManagementMethods: FileManagement;
    transactionIri: string;
}

const ExpenseDocument = ({
    doc,
    expenseFileManagementMethods,
    transactionIri,
}: IExpenseDocumentProps) => {
    const {openModalWithContent, closeModal} = useModal();
    const {
        handleDeleteDocument,
        handleDownloadDocument,
        downloading,
        deleting,
        keyForDownload,
    } = expenseFileManagementMethods;

    const handleDelete = () => {
        openModalWithContent(
            'confirmation',
            <ConfirmationOverlay
                title="Delete file?"
                description="This action cannot be reversed."
                onConfirm={() => {
                    handleDeleteDocument?.({
                        baseUrl: transactionIri!,
                        fileId: doc[keyForDownload],
                    });
                    closeModal('confirmation');
                }}
                confirmVariant="error"
                confirmLabel="Delete"
                onCancel={() => closeModal('confirmation')}
            />,
        );
    };

    return (
        <div className={styles.documentRow}>
            <p data-notranslate>{doc.originalFileName}</p>
            <Button
                iconOnly
                variant="text"
                icon={<IconSVG name="download_old" />}
                onClick={() =>
                    handleDownloadDocument?.(
                        transactionIri,
                        doc[keyForDownload],
                    )
                }
                isLoading={downloading.includes(doc[keyForDownload]!)}
            />
            {handleDeleteDocument ? (
                <Button
                    iconOnly
                    variant="text"
                    icon={<IconSVG name="trash" />}
                    onClick={() => handleDelete()}
                    isLoading={deleting.includes(doc[keyForDownload]!)}
                />
            ) : null}
        </div>
    );
};
